import { isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  Component,
  Inject,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { FacebookService } from '@app/@shared/services/api/facebook.service';
import { GoogleOauthService } from '@app/@shared/services/api/google-oauth.service';
import { PersonService } from '@app/@shared/services/api/person.service';
import { CredentialsService } from '@app/@shared/services/web/credentials.service';
import { MustMatch } from '@app/@shared/services/web/must-match.validator';
import { ToastrService } from '@app/@shared/services/web/toastr.service';
import { AuthenticationService } from '@app/auth/authentication.service';
import { environment } from '@env/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';

declare var google: any;

@Component({
  selector: 'app-registro-social',
  templateUrl: './registro-social.component.html',
  styleUrls: ['./registro-social.component.scss'],
})
export class RegistroSocialComponent implements OnInit, AfterViewInit {
  viewRegister = false;
  loginForm: FormGroup;
  registerForm: FormGroup;
  showRepeatPassword = true;
  submitted = false;
  invalidPassword = false;
  isLoading = false;
  disabledSubmit = false;
  // user: any;
  idUser: number;
  isLodingModal = false;
  emailExists = false;
  isValidEmail =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  isValidDni =
    /^(\d{8})([A-Za-z]){1}$|([A-Za-z])(\d{7})([A-Za-z])|([A-Za-z])(\d{8})$/;
  public googleRequest: any;
  cookieHsUtk: string;

  constructor(
    public credentialsService: CredentialsService,
    public modalService: NgbModal,
    private fb: FormBuilder,
    private authenticationService: AuthenticationService,
    private facebookService: FacebookService,
    private registerService: PersonService,
    public translateService: TranslateService,
    private readonly ingresoSocialModalComponent: MatDialogRef<RegistroSocialComponent>,
    private toastrService: ToastrService,
    public _router: Router,
    private googleOauth: GoogleOauthService,
    private cookieService: CookieService,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(MAT_DIALOG_DATA) public readonly data: any
  ) {
    this.createLoginForm();
  }

  ngOnInit(): void {
    this.cookieHsUtk = this.cookieService.get('hubspotutk');
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.googleRequest = google.accounts.oauth2.initTokenClient({
        client_id: environment.GOOGLE_APP_ID,
        scope:
          'https://www.googleapis.com/auth/userinfo.profile ' +
          'https://www.googleapis.com/auth/userinfo.email ' +
          'https://www.googleapis.com/auth/plus.me',
        prompt: 'consent',
        callback: (tokenResponse: any) => {
          this.googleOauth
            .getUserInfo(tokenResponse.access_token)
            .subscribe((userResponse: any) => {
              this.signUpWithGoogle(userResponse, tokenResponse.access_token);
            });
        },
      });
    }
  }

  closeModal(complete: boolean = false) {
    this.modalService.dismissAll();
    this.ingresoSocialModalComponent.close();
    if (complete && this.data?.redirectTo) {
      this._router.navigate([this.data?.redirectTo]);
    }
  }

  createLoginForm() {
    this.loginForm = this.fb.group({
      email: [
        this.data?.email || null,
        [Validators.required, Validators.pattern(this.isValidEmail)],
      ],
      password: [null, [Validators.required]],
    });
  }

  openDialog(modal: any) {
    this.modalService.open(modal, { ariaLabelledBy: 'modal-nasic-title' });
  }

  login() {
    this.submitted = true;
    if (!this.loginForm.valid) {
      return;
    }
    this.isLoading = true;
    this.disabledSubmit = true;

    const login$ = this.authenticationService.login(this.loginForm.value);
    login$.subscribe(
      (res) => {
        this.isLoading = false;
        this.disabledSubmit = false;
        this.idUser = parseInt(
          this.credentialsService.credentials
            ? this.credentialsService.credentials.id_user
            : null
        );
        this.toastrService.success('a Inviertis', 'Bienvenido');
        this.closeModal(true);
      },
      (error: any) => {
        this.invalidPassword = true;
        this.isLoading = false;
        this.disabledSubmit = false;
        this.toastrService.error(error.error.message, 'Error');
      }
    );
  }

  signUpWithGoogle(user: any, token: string) {
    if (user) {
      const person = {
        first_name: user.given_name,
        last_name: user.family_name,
        email: user.email,
        token,
      };
      this.isLodingModal = true;
      this.registerService.registerGoogle(person).subscribe(
        (x) => {
          this.authenticationService.loginGoogle(token).subscribe((res) => {
            // this.step = 20;
            this.isLodingModal = false;
            this.toastrService.success('a Inviertis', 'Bienvenido');
            this.closeModal(true);
          });
        },
        (error: any) => {
          if (error.error.type == 'duplicate') {
            this.authenticationService.loginGoogle(token).subscribe(
              (res) => {
                // this.step = 20;
                this.isLodingModal = false;
                this.closeModal(true);
              },
              (err) => this.toastrService.error(err.error.message, 'Error')
            );
          } else this.toastrService.error(error.error.message, 'Error');
        }
      );
    }
  }

  async signUpWithFB() {
    this.facebookService.loginWithFacebook().then(
      (resp: any) => {
        const user: any = resp;
        if (user) {
          const person = {
            first_name: user.firstName,
            last_name: user.lastName,
            email: user.email,
            token: user.authToken,
            cookieHsUtk: this.cookieHsUtk,
          };
          this.isLodingModal = true;
          this.registerService.registerFacebook(person).subscribe(
            (x) => {
              this.authenticationService.loginFb(user).subscribe((res) => {
                // this.step = 20;
                this.isLodingModal = false;
                this.toastrService.success('a Inviertis', 'Bienvenido');
                this.closeModal(true);
              });
            },
            (error: any) => {
              if (error.error.type == 'duplicate') {
                this.authenticationService.loginFb(user).subscribe(
                  (res) => {
                    // this.step = 20;
                    this.isLodingModal = false;
                    this.closeModal(true);
                  },
                  (err) => this.toastrService.error(err.error.message, 'Error')
                );
              } else this.toastrService.error(error.error.message, 'Error');
            }
          );
        }
      },
      () => {
        console.log('Inicio de sesión fallido');
      }
    );
  }

  createFormRegister() {
    this.registerForm = this.fb.group(
      {
        first_name: [
          '',
          Validators.compose([
            Validators.required,
            Validators.pattern('^[A-ZñÑa-z0-9\\s]+$'),
            Validators.maxLength(30),
          ]),
        ],
        last_name: [
          '',
          Validators.compose([
            Validators.required,
            Validators.pattern('^[A-ZñÑa-z0-9\\s]+$'),
            Validators.maxLength(30),
          ]),
        ],
        email: [
          '',
          [Validators.required, Validators.pattern(this.isValidEmail)],
        ],
        phone: [
          '',
          Validators.compose([
            Validators.required,
            Validators.pattern(
              '^[+]?([1-9][0-9]*(?:[\\.][0-9]*)?|0*\\.0*[1-9][0-9]*)(?:[eE][+-][0-9]+)?$'
            ),
          ]),
        ],
        password: [
          '',
          [
            Validators.required,
            Validators.pattern(
              '^(?=[^A-Z]*[A-Z])(?=[^a-z]*[a-z])(?=\\D*\\d)[A-ZñÑa-z\\d!¡?¿$%@#£€*&^<>()+-_{}]{8,}$'
            ),
          ],
        ],
        repeat_password: ['', Validators.required],
        acceptNotifications: [false],
      },
      {
        validator: [MustMatch('password', 'repeat_password')],
      }
    );
  }

  register() {
    this.submitted = true;
    if (!this.registerForm.valid) {
      return;
    }
    this.isLoading = true;
    this.createLoginForm();
    const commercialNotify = this.registerForm.get('acceptNotifications').value;
    const newPerson = {
      first_name: this.registerForm.get('first_name').value,
      last_name: this.registerForm.get('last_name').value,
      phone: this.registerForm.get('phone').value
        ? {
            number: this.registerForm.get('phone').value,
          }
        : null,
      user: {
        email: this.registerForm.get('email').value,
        password: this.registerForm.get('password').value,
        receiveNotifications: true,
        receiveNotificationsContent: false,
        receiveNotificationsProcesses: true,
        receiveNotificationsCommercial: false,
      },
      personType: {
        id_person_type: 1,
      },
    };
    if (commercialNotify === true) {
      newPerson.user.receiveNotificationsContent = true;
      newPerson.user.receiveNotificationsCommercial = true;
    }
    this.registerService.register(newPerson).subscribe(
      (x) => {
        this.loginForm.get('email').setValue(newPerson.user.email);
        this.loginForm.get('password').setValue(newPerson.user.password);
        this.login();
      },
      (error: any) => {
        if (error.error.type === 'duplicate') {
          this.emailExists = true;
        }
        this.isLoading = false;
        this.toastrService.error(error.error.message, 'Error');
      }
    );
  }
}
